'use strict';

/**
 * Charts
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.Charts = T.createModule({

	_selectors: {
		// …
	},

	_stateClasses: {
		// …
	},

	_libraryUrl: '/assets/js/highcharts-modules.js',

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		this._events.on('t.sync', this.sync.bind(this));

		// Lifecycle Callback
		resolve();
	},
	sync: function sync() {
		this.loadLibrary();
	},
	loadLibrary: function loadLibrary() {
		$.fn.loadScript(this._libraryUrl, this.onLibraryLoadedCallback.bind(this));
	},
	onLibraryLoadedCallback: function onLibraryLoadedCallback() {
		this._events.emit('charts.libraryLoaded');
	}
});